<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('selfhelp')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">New ToolKits</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <p class="mb-1">Title</p>
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Write Title here"
          v-model="title"
        >
        </base-input>
        <!-- :rules="{ required: true }" -->
        <p class="mb-1">Description</p>
        <base-input
          alternative
          class="mb-3"
          name="description"
          :rules="{ required: true }"
          placeholder="Write Description here"
          v-model="description"
          :maxlength="500"
          @input="limitDescription"
        >
        </base-input>
        <p>
          only this much Characters are allowed {{ description.length }} / 500
        </p>

        <p class="font-semibold mt-6 mb-2 text-xl">Upload Image</p>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
          accept="image"
        />
        (Dimensions should H-700, W-900)
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
        <img v-if="image" :src="image" ref="cover" />
        <!-- <quill-editor
          v-model="body"
          :options="editorOption"
          class="quill-h200px my-2"
        /> -->

        <div class="my-6">
          <p class="font-semibold mb-2 text-xl">Attach your files</p>
          <b-form-file
            v-model="file1"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            accept=".doc,.docx,.pdf,.txt"
          ></b-form-file>
          <!-- <span class="small text-danger">{{
            "Upload Only Docx or PDF files"
          }}</span> -->
        </div>
        <div class="my-6">
          <p class="font-semibold mb-2 text-xl">Read Time(in minutes)</p>
          <base-input
            alternative
            class="mb-3"
            name="readtime"
            :rules="{ required: true, numeric: true }"
            placeholder="Enter reading time"
            v-model="readtime"
          >
          </base-input>
        </div>
        <div class="my-6">
          <p class="font-semibold mb-2 text-xl">Type</p>
          <b-form-select
            v-model="paytype"
            :options="optionstype"
            class="mt-3"
            required
          ></b-form-select>
        </div>
        <div class="mb-2">
          <b-form-group label="Tags:">
            <div class="md:flex justify-between items-center">
              <b-form-select v-model="selectedtag" required class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[0].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag1 in filter1"
                  :value="filtertag1._id"
                  :key="filtertag1._id"
                  >{{ filtertag1.name }}</b-form-select-option
                >
              </b-form-select>
              <b-form-select v-model="selectedSeg" required class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[1].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag2 in filter2"
                  :value="filtertag2._id"
                  :key="filtertag2._id"
                  >{{ filtertag2.name }}</b-form-select-option
                >
              </b-form-select>
              <b-form-select v-model="selectedUsers" required class="">
                <b-form-select-option :value="null" disabled>
                  Select {{ filters.length ? filters[2].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag3 in filter3"
                  :value="filtertag3._id"
                  :key="filtertag3._id"
                  >{{ filtertag3.name }}</b-form-select-option
                ></b-form-select
              >
            </div>
          </b-form-group>
        </div>

        <div class="mb-2">
          <b-form-checkbox id="checkbox-2" v-model="onlyRegistered">
            <p>
              <strong>
                <p class="col-blk">
                  Click here to restrict access to this tool kit for registered
                  users only.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>
        <div class="mb-2 w-1/3">
          <label for="membership">Membership:</label>
          <multiselect
            name="membership"
            v-model="selectedMembership"
            :options="membershipFilter"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Memberships"
            track-by="name"
            label="name"
            :preselect-first="false"
            :disabled="!onlyRegistered ? true : false"
          >
          </multiselect>
        </div>

        <!-- <div class="grid grid-cols-2 gap-4 mt-3">
          <div>
            <p class="mb-1">Meta Title</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaTitle"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Description</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaDesc"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Canonical Tag</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaCanonicalTag"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Keyword</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaKeyword"
            >
            </base-input>
          </div>
        </div> -->

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      file1: null,
      title: "",
      description: "",
      image: null,
      coverImage: null,
      body: "",
      editorOption: {
        theme: "snow",
      },
      selectedtag: null,
      selectedUsers: null,
      selectedSeg: null,
      Ctags: [],
      filter1: [],
      filter2: [],
      filter3: [],
      paytype: null,
      optionstype: [
        { value: null, text: "Select" },
        { value: "Paid", text: "Paid" },
        { value: "Free", text: "Free" },
      ],
      readtime: "",
      imageErr: false,
      msg: {
        image: "",
      },
      selectedMembership: null,
      membershipFilter: [],
      onlyRegistered: false,

      // metaTitle: "",
      // metaKeyword: "",
      // metaDesc: "",
      // metaCanonicalTag: "",
    };
  },
  computed: {
    ...mapState("cms", {
      filtertags: "filtertags",
      filters: "filters",
      selectedpagecategory: "selectedpagecategory",
    }),
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
  },
  methods: {
    limitDescription(event) {
      if (this.description.length > 500) {
        this.description = this.description.substring(0, 500);
      }
    },
    handleSuccess(image) {
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        let mByte = 5 * 1048576;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },

    async onSubmit() {
      if (!this.onlyRegistered) {
        this.selectedMembership = null;
      }
      if (this.file1 != null) {
        if (
          !this.file1.type.includes("pdf") &&
          !this.file1.type.includes("doc") &&
          !this.file1.type.includes("docx") &&
          !this.file1.type.includes("text") &&
          !this.file1.type.includes("txt") &&
          !this.file1.type.includes("odt")
        ) {
          this.$swal({
            text: "Please choose PDF, Word or Text file for attachment!",
            icon: "info",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          return;
        }
      } else {
        this.$notify.error({
          message: "File is required!",
          position: "top-right",
        });
        return;
      }
      let FormData = require("form-data");
      let data = new FormData();
      this.Ctags.push(this.selectedtag, this.selectedSeg, this.selectedUsers);
      data.append("type", "single");
      data.append("title", this.title.replaceAll(/\s{2,}/g, " "));
      data.append("description", this.description);
      data.append("subTitle", "");
      data.append("media", this.coverImage);
      data.append("file", this.file1);
      data.append("html", this.body);
      data.append("readTime", this.readtime);
      data.append("paytype", this.paytype);
      data.append("tags", JSON.stringify(_.uniq(this.Ctags)));
      data.append("pageCategory", this.selectedpagecategory.id);

      // data.append("metaKeyword", this.metaKeyword);
      // data.append("metaCanonicalTag", this.metaCanonicalTag);
      // data.append("metaDesc", this.metaDesc);
      // data.append("metaTitle", this.metaTitle);

      data.append("memberships", JSON.stringify(this.selectedMembership));
      if (this.selectedMembership !== null) {
        data.append("onlySubscribed", true);
        data.append("onlyRegistered", true);
      } else {
        data.append("onlyRegistered", this.onlyRegistered);
        data.append("onlySubscribed", false);
      }

      let loader = this.$loading();

      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      try {
        const selfhelpdata = await this.$store.dispatch("cms/addPage", data);
        if (selfhelpdata.code == 200) {
          this.$router.push({ name: "selfhelp" });
          this.$swal.fire({
            text: "Toolkit entry successfully submitted",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }

        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    async gettagsbycategory(payload) {
      this.filter1 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[0]._id
      );
      this.filter2 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[1]._id
      );
      this.filter3 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[2]._id
      );
      let filteredMembershipAPIData = await this.$store.dispatch(
        "subscribe/GetAllMembership"
      );
      this.membershipFilter = this.get_all_membership.filter((membership) => {
        if (
          membership.name.toLowerCase() !== "visitor" &&
          membership.name.toLowerCase() !== "registered"
        ) {
          return true;
        }
        return false;
      });
    },
  },
  mounted() {
    this.gettagsbycategory();
  },
  watch: {
    membershipFilter() {
      if (this.blog_data.memberships && this.blog_data.memberships.length > 0) {
        this.selectedMembership = this.membershipFilter.filter((membership) => {
          let data = this.blog_data.memberships.find(
            (member) => member._id === membership._id
          );
          // return this.blog_data.memberships.includes(membership._id);
          return data;
        });
        // console.log(this.selectedMembership);
      }
    },
  },
};
</script>
